<template>
  <a-modal
    :maskClosable="false"
    :title="modalTitle"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    :okButtonProps="{ props: {disabled:disabled} }"
    @ok="handleSubmit"
    @cancel="visible=false"
  >
    <a-form layout="horizontal" :form="form" @submit="handleSubmit">
      <a-form-item label="模块名称" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
          type="text"
          v-decorator="[
            'moduleName',
            {rules: [{ required: true, message: '请输入模块名称' }]}
          ]"
          :disabled="disabled"
        />
      </a-form-item>

      <!-- <a-form-item label="图标" :labelCol="{lg: {span: 4}}" :wrapperCol="{lg: {span: 8}}">
          <c-upload
            ref="moduleIcon"
            :ossType="'module'"
            :isSingle="true"
            @uploadSuccess="uploadSuccess"
          ></c-upload>
      </a-form-item>-->

      <a-form-item label="关联标签" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-select
          class="form-cell"
          placeholder="请选择关联标签"
          :disabled="disabled"
          v-decorator="[
            'tagId',
            { rules: [{ required: true, message: '请选择关联标签' }] },
            ]"
        >
          <a-select-option
            v-for="(item,index) in tags"
            :value="item.id"
            :key="index"
          >{{item.tagName}}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="排序" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input-number
          :min="0"
          :disabled="disabled"
          v-decorator="[
                  'seq',
                  {initialValue:0},
                  {rules: [{ required: false, min:0, message: '优先级' }]}
                ]"
        />&emsp;数字越大越靠前显示
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import appModule from "../../api/appModule";
import notification from "ant-design-vue/es/notification";
import CUpload from "../../components/CUpload/CUpload";

export default {
  name: "appModuleForm",
  components: { CUpload },
  data() {
    return {
      modalTitle: "",
      type: "",
      id: -1,
      visible: false,
      confirmLoading: false,
      disabled: false, //是否禁止编辑
      moduleIcon: "", //模块图标路径
      tags: [],
      //这个是写死的路径;社团课: /icon/icon_mass_org.png;兴趣班: /icon/icon_interest.png;安心班: /icon/icon_daycare.png;活动: /icon/icon_activity.png;
      iconUrl:['icon/icon_mass_org.png','icon/icon_interest.png','icon/icon_daycare.png','icon/icon_activity.png'],
    };
  },
  methods: {
    //初始化，显示
    init(type, params) {
      this.id = params.id;
      this.type = type;
      this.visible = true;
      let id = this.id;
      //获取详情
      if (this.type == "add") {
        this.disabled = false;
        this.modalTitle = "新增模块";
        this.form.resetFields();
        // setTimeout(() => {
        //   this.$refs.moduleIcon.imageUrl = "";
        // }, 100);
      }
      //获取详情
      if (this.type == "edit") {
        this.disabled = false;
        this.modalTitle = "修改模块";
        this.getDetail(id);
      }
    },
    //提交
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log(values);
        //校验通过
        if (!err) {

          let newValues = {
            moduleName: values.moduleName ? values.moduleName : "",
            // moduleIcon: this.moduleIcon,
            seq: values.seq
          };
          if (values.tagId && values.tagId != "") {
            newValues.tagId = values.tagId;
            if(newValues.tagId==1){
              newValues.moduleIcon=window.globalConfig.fileUrl+this.iconUrl[0];
            }
            if(newValues.tagId==2){
              newValues.moduleIcon=window.globalConfig.fileUrl+this.iconUrl[1];
            }
            if(newValues.tagId==3){
              newValues.moduleIcon=window.globalConfig.fileUrl+this.iconUrl[2];
            }
            if(newValues.tagId==31){
              newValues.moduleIcon=window.globalConfig.fileUrl+this.iconUrl[3];
            }
          }
          if (this.type == "add") {
            //  console.log(newValues);
            this.add(newValues);
          }
          if (this.type == "edit") {
            this.edit(newValues);
          }
        }
      });
    },
    //新增
    add(params) {
      appModule.add(params).then(res => {
        console.log("数据：", res);
        notification.success({
          message: "消息",
          description: "新增成功！"
        });
        let currentPage = this.$parent.pagination.current;
        let pageSize = this.$parent.pagination.pageSize;
        this.$parent.getAppModuleList({ currentPage, pageSize });
        this.visible = false;
      });
    },
    //修改
    edit(params) {
      params.id = this.id;
      appModule.edit(params).then(res => {
        console.log("数据：", res);
        notification.success({
          message: "消息",
          description: "修改成功！"
        });
        let currentPage = this.$parent.pagination.current;
        let pageSize = this.$parent.pagination.pageSize;
        this.$parent.getAppModuleList({ currentPage, pageSize });
        this.visible = false;
      });
    },
    //获取详情
    getDetail(id) {
      appModule.detail({ id }).then(res => {
        // console.log(res);
        let appModule = res.data;
        this.clickType = appModule.clickType;
        console.log(appModule);
        let detail = {
          moduleName: appModule.moduleName,
          // moduleIcon: appModule.moduleIcon,
          tagId: appModule.tagId,
          seq: appModule.seq
        };
        // this.$refs.moduleIcon.imageUrl =res.data.moduleIcon;
        setTimeout(() => {
          this.form.setFieldsValue(detail);
        }, 100);
      });
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    uploadSuccess(e) {
      console.log("e", e);
      this.moduleIcon = e ? e : "";
    },
    //返回
    back() {
      this.$router.back();
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "dynamic_form_item" });
  },
  created() {
    this.tags = this.$store.state.common.tags.filter(
      item => item.tagGroup == 1
    );
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>